import React from 'react';

export default function Home() {
  return (
    <div style={{
      width: '54rem', margin: '0 auto', fontFamily: 'Poppins', letterSpacing: '1px',
    }}
    >
      <h1 style={{ color: '#00c2cb' }}>Welcome to our page</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim illum vel
        modi cupiditate, voluptatem vitae consequuntur, culpa quidem eligendi
        pariatur nostrum minima labore ipsum. Error labore ex illo libero esse.
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis animi
        ut asperiores consequuntur? Molestiae obcaecati esse nostrum molestias
        non officia dolorum magnam natus saepe recusandae blanditiis, doloremque
        dolores! Veniam, a.
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim illum vel
        modi cupiditate, voluptatem vitae consequuntur, culpa quidem eligendi
        pariatur nostrum minima labore ipsum. Error labore ex illo libero esse.
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores
        voluptates numquam impedit minus nobis repellat, culpa nam dolore, velit
        praesentium eveniet accusamus laborum ab vel, dignissimos nesciunt
        distinctio unde provident.
      </p>
    </div>
  );
}
